import React from "react";
import InventoryReport from "./InventoryReports";

// Api/Reports/ProductStockReport - see InventoryReports.jsx
const StockProductReport = () => <InventoryReport kind="stock" />;

export default StockProductReport;
